// extracted by mini-css-extract-plugin
export default {"CodingPage__modalButtonBox":"CodingPage_CodingPage__modalButtonBox__hsRia","CodingPage__modalButton":"CodingPage_CodingPage__modalButton__gylOP"};